export enum BouwenEnum {
  JA, minimale_aandacht = 'Ja, minimale aandacht',
  JA_RUIME_AANDACHT = 'Ja, ruime aandacht',
  NEE = 'Nee',
  ONBEKEND = 'Onbekend',
}
